import AboutHotel from './AboutHotel';

export default AboutHotel;
